<template>
  <div class="page-body">
    <div class="card bg-light-gray w-100 m-0">
      <div class="card-body pt-1">
        <div class="table-responsive">
          <table
            role="table"
            aria-busy="false"
            aria-colcount="8"
            class="table-v3 w-100"
          >
            <thead role="rowgroup">
              <tr role="row">
                <th class="nowrap">Nro. Ap.</th>
                <th class="nowrap">Tomador</th>
                <th class="nowrap">Segurado</th>
                <th class="nowrap">Prêmio Pago</th>
                <th class="nowrap">Vencimento</th>
                <th class="nowrap text-center">Status</th>
                <th class="nowrap text-center">Prazo p/ Vencer</th>
                <th class="nowrap">Ação</th>
              </tr>
            </thead>
            <tbody role="rowgroup">
              <tr v-for="policy in policies" :key="policy.id" role="row">
                <td data-column-title="Nro. Ap." class="font-12">
                  {{ policy.number ?? policy.policy_origin.number }}
                </td>
                <td data-column-title="Tomador" class="font-12">
                  <span
                    class="truncate-200 truncate-xxl-275"
                    :title="policy.policy_holder_name || '--'"
                    >{{ truncateText(policy.policy_holder_name ?? "--") }}</span
                  >
                </td>
                <td data-column-title="Segurado" class="font-12">
                  <span
                    class="truncate-200 truncate-xxl-275"
                    :title="policy.insured_name"
                    >{{ truncateText(policy.insured_name) }}</span
                  >
                </td>
                <td data-column-title="Prêmio Pago" class="font-12">
                  {{
                    formatCurrency(
                      policy.policy_origin
                        ? policy.policy_origin.insurance_premium
                        : policy.insurance_premium
                    )
                  }}
                </td>
                <td data-column-title="Vencimento" class="font-12">
                  {{
                    formatDateLocal(
                      policy.validity_expiration ??
                        policy.policy_origin.validity_expiration
                    )
                  }}
                </td>
                <td data-column-title="Status" class="font-12 text-center">
                  <span
                    class="btn btn-sm text-uppercase rounded-pill"
                    :class="getStatusClass(policy.status ?? policy.status_id)"
                    style="
                      background-color: var(--status-color);
                      color: #fff;
                      min-width: 120px;
                    "
                  >
                    {{ translateStatus(policy.status ?? policy.status_id) }}
                  </span>
                </td>
                <td
                  data-column-title="Prazo p/ Vencer"
                  class="font-12 text-center"
                >
                  <span
                    class="btn btn-sm rounded-pill text-white"
                    :class="{
                      'btn-danger': policy.deadline < 7,
                      'btn-warning':
                        policy.deadline >= 7 && policy.deadline < 15,
                      'btn-success': policy.deadline >= 15,
                    }"
                    style="min-width: 60px"
                  >
                    {{
                      policy.deadline > 0
                        ? policy.deadline + " dias"
                        : "há " + Math.abs(policy.deadline) + " dias"
                    }}
                  </span>
                </td>

                <td class="text-center">
            <div class="d-flex justify-content-end align-items-center">
              <a v-if="policy.status == 1 || policy.status == 2" @click="showModalCreate(policy)" class="btn btn-action">
                <i class="fa fa-sync"></i>
              </a>
              <a v-else class="btn-action" style="visibility: hidden;">
                <i class="fa fa-sync"></i>
              </a>
              <a
                @click="$can('policy-show') ? redirect('details-policy', { policyId: (policy.policy_origin && policy.policy_origin.id ? policy.policy_origin.id : policy.id) }) : ''"
                class="btn btn-action">
                <i class="fas fa-eye"></i>
              </a>
              <b-dropdown variant="ellipsis" size="sm" menu-class="custom-dropdown-menu-items" class="b-dropdown-custom-color" left no-caret>
                <template #button-content>
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item v-if="policy.status != 1 && policy.status != 2"
                  @click="showModalStatus(policy, policy.status)">
                  <i class="fa fa-pencil-alt"></i> Alterar renovação da apólice
                </b-dropdown-item>
                <b-dropdown-item v-if="policy.status != 1 && policy.status != 2" @click="downloadAllFile(policy)">
                  <i class="fa fa-file-alt"></i> Fazer download de todos os documentos
                </b-dropdown-item>
                <b-dropdown-item v-if="(policy.status == 1 || policy.status == 2) && isMaster()" @click="automaticRenewal(policy)">
                  <i class="fa fa-clock font-16 me-1"></i> Renovação automática
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginação -->
        <div>
          <b-pagination 
            v-model="currentPage"
            :total-rows="totalPolicies" 
            :per-page="perPage" 
            aria-controls="my-table"
            class="my-3 mb-4 pagination-renewal">
          </b-pagination>
        </div>
      </div>
    </div>

    <!-- Modal: Renovar Manual -->
    <b-modal
      id="show-modal-create"
      ref="modalCreate"
      size="md"
      hide-footer
      centered
    >
      <template #modal-title>Renovar apólice</template>
      <ManualPolicyRenewal :policy-renew-selected="policyRenewSelected" />
    </b-modal>

    <!-- Modal: Renovação Automática -->
    <b-modal
      id="show-modal-automatic-renewal"
      ref="modalAutomaticRenewal"
      size="lg"
      hide-footer
    >
      <template #modal-title>Renovar apólice</template>
      <AutomaticPolicyRenewal :policy-id="policyIdSelected" />
    </b-modal>

    <!-- Modal: Alterar Status -->
    <b-modal
      id="modal-renovation-status"
      ref="modalStatus"
      size="lg"
      @hide="closeModalStatus"
    >
      <template #modal-title>
        <h5 class="modal-title">Alterar Renovação</h5>
        <p class="text-muted mb-0">Revise e altere o status da renovação</p>
      </template>
      <ModalStatusRenewal
        :policy-renew-selected="policyRenewSelected"
        :editing="editing"
        :url-upload="urlUpload"
        :files="files"
        @close-modal-status="closeModalStatus"
        @disable-status-button="disableStatusButton"
        ref="modalStatusRenewal"
      />
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-primary"
          @click="
            editing ? changeStatusPolicyRenovation() : $refs.modalStatus.hide()
          "
          :disabled="disable_status_button"
        >
          <b-spinner v-if="loading" small></b-spinner>
          {{ editing ? "Alterar" : "Fechar" }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import dateFormatter from "@/mixins/dateFormatter";
import numericFormatterMixin from "@/mixins/numericFormatter";
import authenticationService from "@/services/authentication";
import policyService from "@/services/policy";
import policyRenovationService from "@/services/policy-renovation";
import fileDownload from "js-file-download";
import commomsHelper from "@/mixins/commomsHelper";
import ManualPolicyRenewal from "@/components/Policy/Renewal/ManualPolicyRenewal.vue";
import ModalStatusRenewal from "@/components/Policy/Renewal/ModalStatusRenewal.vue";
import AutomaticPolicyRenewal from "@/components/Policy/Renewal/AutomaticPolicyRenewal.vue";

export default {
  name: "ListPolicyRenewal",
  mixins: [numericFormatterMixin, dateFormatter, commomsHelper],
  components: {
    ManualPolicyRenewal,
    ModalStatusRenewal,
    AutomaticPolicyRenewal,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      policies: [],
      totalPolicies: 0,
      policyRenewSelected: {},
      editing: false,
      loading: false,
      files: [],
      urlUpload: "",
      policyIdSelected: null,
      disable_status_button: true,
      filters: {
        policy_holder: "",
        insured: "",
        policy_number: "",
        status_renovation: "",
        reason_cancellation: "",
      },
    };
  },
  created() {
    this.getPoliciesRenovationsList();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalPolicies / this.perPage) || 1;
    },
    pages() {
      // mostra até 3 páginas: atual, anterior e próxima
      const pages = [];
      let start = Math.max(1, this.currentPage - 1);
      let end = Math.min(this.totalPages, start + 2);
      // se faltar na direita, tenta preencher da esquerda
      if (end - start < 2) {
        start = Math.max(1, end - 2);
      }
      for (let p = start; p <= end; p++) {
        pages.push(p);
      }
      return pages;
    },
  },
  watch: {
    currentPage() {
      this.getPoliciesRenovationsList(
        this.filters.policy_holder,
        this.filters.insured,
        this.filters.policy_number,
        this.filters.status_renovation,
        this.filters.reason_cancellation
      );
    },
  },
  methods: {
    truncateText(text, maxChar = 28) {
      return text.length > maxChar ? `${text.substring(0, maxChar)}...` : text;
    },
    formatDateLocal(date) {
      return new Date(date).toLocaleDateString("pt-BR");
    },
    translateStatus(status) {
      const statusMap = {
        1: "Renovação próxima",
        2: "Aguardando contato",
        15: "Aguardando doc",
        18: "Aguardando aprovação",
        16: "Finalizada",
        9: "Cancelada",
      };
      return statusMap[status] || "Desconhecido";
    },
    getStatusClass(status) {
      const statusClassMap = {
        1: "kanban-list-status-orange",
        2: "kanban-list-status-orange-66",
        15: "kanban-list-status-orange-33",
        18: "kanban-list-status-yellow",
        16: "kanban-list-status-green",
        9: "kanban-list-status-red",
      };
      return statusClassMap[status] || "kanban-list-status-orange";
    },
    showModalCreate(policy) {
      if (policy) {
        this.policyRenewSelected = policy;
        this.$refs.modalCreate.show();
      }
    },
    showModalStatus(policy, column) {
      if (column !== 9) {
        policy.cancellation_reason_id = null;
      }
      policy.status_id = column;
      this.editing = column == 15 || column == 18;
      if (policy) {
        this.urlUpload = `/api/v1/policy-renovations/${policy.id}/files`;

        policy.user_id = policy.user.id;
        policy.policy_origin_id = policy.policy_origin.id;
        policy.policy_number = policy.number;
        policy.quotation_id = policy.quotation.id;
        this.policyRenewSelected = policy;
        this.$refs.modalStatus.show();
      }
    },
    getClassTextColor(days) {
      if (days < 7) {
        return "pill-label-danger";
      } else if (days < 15) {
        return "pill-label-warning";
      }
      return "pill-label-success";
    },
    redirect(routeName, params = null, query = null) {
      this.$router.push({ name: routeName, params: params, query: query });
    },
    automaticRenewal(policy) {
      this.policyIdSelected = policy.id;
      this.$refs.modalAutomaticRenewal.show();
    },
    createRenovation(policy) {
      this.$emit("create-renovation", policy);
    },
    isMaster() {
      return authenticationService.isMaster();
    },
    closeModalStatus() {
      this.$refs.modalStatus.hide();
      this.getPoliciesRenovationsList();
    },
    getPoliciesRenovationsList(
      policy_holder = "",
      insured = "",
      policy_number = "",
      status_renovation = "",
      reason_cancellation = "",
      is_clear = false
    ) {
      this.$emit("update-loading", true);
      let page = is_clear ? 1 : this.currentPage;
      this.filters = {
        policy_holder,
        insured,
        policy_number,
        status_renovation,
        reason_cancellation,
      };

      policyService
        .getPoliciesRenovationsList({
          page: page,
          per_page: this.perPage,
          policy_holder: policy_holder,
          insured: insured,
          policy_number: policy_number,
          status_renovation: status_renovation,
          reason_cancellation: reason_cancellation,
        })
        .then((response) => {
          if (!response.data.error) {
            this.policies = response.data.data;
            this.totalPolicies = response.data.total;
            this.currentPage = page;
          }
        })
        .catch(() => {
          this.$emit(
            "show-error",
            "Não foi possível recuperar as apólices a vencer."
          );
        })
        .finally(() => {
          this.$emit("update-loading", false);
        });
    },
    downloadAllFile(policyRenovation) {
      this.loading_download = true;
      policyRenovationService
        .getPolicyRenovationAllFiles(policyRenovation.policy_renovation_id)
        .then((response) => {
          if (response.data.error) {
            this.$emit("show-error", response.data.message);
            return;
          }
          fileDownload(response.data, "download.zip");
          this.loading_download = false;
        })
        .catch(() => {
          this.$emit(
            "show-error",
            "Não foi possível realizar o download deste arquivo."
          );
        });
    },
    disableStatusButton(value) {
      this.disable_status_button = value;
    },
    changeStatusPolicyRenovation() {
      this.$emit("update-loading", true);
      this.resetAlert();
      policyRenovationService
        .updateStatusPolicyRenovation(
          this.policyRenewSelected.policy_renovation_id,
          this.policyRenewSelected
        )
        .then((response) => {
          if (response.data.error) {
            this.$emit("show-error", response.data.message);
            return;
          }
          this.$refs.modalStatusRenewal.uploadFiles();
        })
        .catch(() => {
          this.$emit(
            "show-error",
            "Não foi possível mudar o status da renovação."
          );
        })
        .finally(() => {
          this.$emit("update-loading", false);
          this.getPoliciesRenovationsList();
        });
    },
    pageChanged(page) {
      this.loading = true;
      if (page < 1 || page > this.totalPages || page === this.currentPage)
        return;
      this.fetchList(page);
    },
    fetchList(page = this.currentPage) {
      this.loading = true;
      const params = {
        page,
        per_page: this.perPage,
        ...this.filters,
      };
      policyService
        .getPoliciesRenovationsList(params)
        .then(({ data }) => {
          if (!data.error) {
            this.policies = data.data;
            this.totalPolicies = data.total;
            this.currentPage = page;
          }
        })
        .catch(() => {
          this.$emit("show-error", "Não foi possível recuperar as apólices.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
